export const SCROLL_ICON_WIDTH = 12
